import { type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type FeaturedIconProps = {
  icon: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?:
    | 'gray'
    | 'red'
    | 'yellow'
    | 'green'
    | 'accent'
    | 'orange'
    | 'accent-contrast'
    | 'accent-darker';
  border?: boolean;
  className?: string;
};

export function FeaturedIcon(props: FeaturedIconProps) {
  const { icon, size = 'md', color = 'green', border = true, className = '' } = props;
  const shapeClassNames = 'flex shrink-0 items-center justify-center rounded-full';
  const circleClassNames = {
    gray: 'bg-branding-gray-100 border-branding-lg text-branding-gray-600 outline-branding-gray-50',
    red: 'bg-red-100  outline-red-50 text-red-600',
    yellow: 'bg-yellow-100  outline-yellow-50 text-yellow-600',
    green: 'bg-green-100  outline-green-50 text-green-600',
    accent: 'bg-branding-accent-100  outline-branding-accent-50 text-branding-accent-600',
    orange: 'bg-orange-100  outline-orange-50 text-orange-400',
    'accent-contrast': 'bg-branding-accent text-white',
    'accent-darker': 'bg-branding-accent-200  outline-branding-accent-100 text-branding-accent',
  }[color];
  const circleSizeClassNames = {
    xs: 'size-6 [&>svg]:size-3',
    sm: 'size-8 [&>svg]:size-4',
    md: 'size-10 [&>svg]:size-5',
    lg: 'size-12 [&>svg]:size-6',
  }[size];

  const borderClassNames = {
    xs: ' outline outline-2',
    sm: ' outline outline-4',
    md: ' outline outline-[6px]',
    lg: ' outline outline-[8px]',
  }[size];

  return (
    <div
      className={twMerge(
        shapeClassNames,
        circleClassNames,
        circleSizeClassNames,
        border ? borderClassNames : '',
        className
      )}
    >
      {icon}
    </div>
  );
}
